<template>
<div :style="style" :class="position" ref="root" class="background-image pointer-events-none absolute z-10 left-0 top-0 w-full h-full bg-cover" v-bind:aria-hidden="!alt.length">
    <span v-if="alt.length" class="sr-only" v-html="alt"></span>
</div>
</template>

<script>
import { computed, onMounted, onBeforeUnmount, ref } from 'vue';
const $ = window.jQuery;
export default {

    props: {
        position: {
            type: String,
            default: 'bg-center'
        },
        parallax: {
            default: false
        },
        opacity: {
            default: 1
        },
        alt: {
            type: String,
            default: ''
        },
        src: {
            type: String,
            required: true
        }
    },
    
    setup(props) {

        const root = ref(null);
        const style = computed(() => {
            let output = `background-image:url(${props.src});`;
            if (props.opacity != 1) {
                output = output + `opacity: ${props.opacity};`;
            }
            return output;
        });

        // Parallax
        // ========

        const parallaxScrollTrigger = function() {
            let $root = $(root.value);
            const scrollDiff = (() => {
                let top_of_screen = $(window).scrollTop();
                let top_of_element = $root.parent().offset().top;
                return top_of_screen - top_of_element;
            })();
            if ($root.parent().isInViewport()) {
                let shift = Math.round(scrollDiff * props.parallax);
                const transform = `translate3d(0, ${shift}px, 0)`;
                $root.css('transform', transform);
            }
        };

        if (props.parallax && !window.prefersReducedMotion()) {
            onMounted(() => {
                $(window).on('scroll', parallaxScrollTrigger);
            });
            onBeforeUnmount(() => {
                $(window).off('scroll', parallaxScrollTrigger);
            });
        }

        return {
            root,
            style
        }

    }

}
</script>